export default __webpack_public_path__ + "static/media/Mangerica-Bold.4148197c.otf";